import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  BuyerSurveyResponse,
  Survey,
} from '../../../shared/interfaces/survey.interface';

@Component({
  selector: 'ps-ui-multi-locale-field-label',
  templateUrl: './multi-locale-field-label.component.html',
  styleUrls: ['./multi-locale-field-label.component.css'],
})
export class MultiLocaleFieldLabelComponent implements OnChanges {
  @Input() selectedSvpChildSurvey = <Survey>{};
  @Input() field: keyof BuyerSurveyResponse;
  @Input() mcSvpChildSurveys: BuyerSurveyResponse[] = [];

  public showMultipleLabel = false;

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.mcSvpChildSurveys?.currentValue) {
      this.showMultipleLabel = !this._isUnique();
    }
  }

  private _isUnique(): boolean {
    return (
      [
        ...new Set(
          this.mcSvpChildSurveys.map((s) =>
            typeof s[this.field] === 'object'
              ? JSON.stringify(s[this.field])
              : s[this.field]
          )
        ),
      ].length === 1
    );
  }
}
